"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighScores = exports.CTGHighScores = exports.CTGScore = void 0;
class CTGScore {
    constructor(score) {
        this.score = score;
    }
    to_json() {
        return {
            "score": this.score,
        };
    }
}
exports.CTGScore = CTGScore;
class CTGHighScores {
    constructor(save_key) {
        this._save_key = save_key;
        this.load_high_scores();
    }
    get_best_score(key) {
        const scores = this._scores[key];
        if (!scores || scores.length == 0)
            return null;
        else {
            return scores[0].score;
        }
    }
    is_new_best(key, score, low_is_better) {
        const best_score = this.get_best_score(key);
        if (best_score == null)
            return true;
        return ((low_is_better && score.score < best_score)
            || (!low_is_better && score.score > best_score));
    }
    add_high_score(key, score, low_is_better) {
        let saveKey = key;
        if (!(saveKey in this._scores)) {
            this._scores[saveKey] = [];
        }
        let scores = this._scores[saveKey];
        scores.push(score.to_json());
        scores.sort((a, b) => {
            let val1 = a.score, val2 = b.score;
            if (low_is_better) {
                return val1 - val2;
            }
            else {
                return val2 - val1;
            }
        });
        this._scores[saveKey] = scores.slice(0, 10);
        this.save_high_scores();
    }
    load_high_scores() {
        let jsonStr = "";
        try {
            jsonStr = localStorage.getItem(this._save_key);
        }
        catch (e) {
            console.log("LocalStorage access denied. Options and scores will not be saved.");
        }
        try {
            let json = JSON.parse(jsonStr);
            if (!json) {
                json = {};
            }
            this._scores = json;
        }
        catch (e) {
            console.log("Error parsing high score: " + jsonStr);
            this._scores = {};
        }
    }
    save_high_scores() {
        try {
            localStorage.setItem(this._save_key, JSON.stringify(this._scores));
        }
        catch (e) {
            console.log("LocalStorage access denied. Options and scores will not be saved.");
        }
    }
    reset() {
        this._scores = {};
        this.save_high_scores();
    }
}
exports.CTGHighScores = CTGHighScores;
exports.HighScores = new CTGHighScores('CTG_highscores');
console.log(exports.HighScores);
